import { useState, useEffect } from 'react';
import { capitalizeFirstLetter } from '../../utils'
import { apiClient } from '../../api_actions';
import { orbitalSpinner } from '../LoadingOrbitalSpinner/LoadingOrbitalSpinner';
import { chartTheme } from '../../constants/chartTheme';

// Separate data transformation
const transformEventData = (data) => {
    return data
        .map(item => ({
            type: capitalizeFirstLetter(item.type?.replace(/_/g, ' ').replace(/\s(\.)/g, ',')),
            value: Number(item.value)
        }))
        .sort((a, b) => b.value - a.value);
};

// Separate API call
const fetchEventsByTypeData = async (startAndEndUnixDatesParams = '') => {
    try {
        const res = await apiClient.post(`read/dashboardevents?${startAndEndUnixDatesParams()}`);
        if (res.status && res.data) {
            return transformEventData(res.data);
        }
        return [];
    } catch (error) {
        console.error('Failed to load data:', error);
        return [];
    }
};

// Factory function - simplified
const createEventsByTypeConfig = (data = [], formatDateRange = () => '') => ({
    theme: chartTheme,
    series: [
        {
            type: 'pie',
            angleKey: 'value',
            calloutLabelKey: 'type',
        },
    ],
    title: { text: 'Events by Type' },
    subtitle: { text: formatDateRange() },
    data: data,
    overlays: {
        loading: {
            renderer: orbitalSpinner,
        },
    },
});

export const EventsByTypeChartLogic = (startAndEndUnixDatesParams, formatDateRange) => {
    const [EventsByTypeConfig, setEventsByTypeConfig] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            const data = await fetchEventsByTypeData(startAndEndUnixDatesParams);
            setEventsByTypeConfig(createEventsByTypeConfig(data, formatDateRange));
            setLoading(false);
        };

        loadData();
    }, [startAndEndUnixDatesParams, formatDateRange]);

    return {
        EventsByTypeConfig,
        loading,
    };
};
